import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";
import { reducerPaths } from "../../app/reducerPaths";

export const carsInNegotiationApi = createApi({
  reducerPath: reducerPaths.carsInNegotiationApi,
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getOwnCarsInNegotiation: builder.query({
      query: ({ params }) => {
        return {
          url: `/myGarage/Seller/CarsInNegotiation`,
          method: "GET",
          params   
        }
      }
    }),
    getOwnCarsInNegotiationBuyNow: builder.query({
      query: ({ params }) => {
        return {
          url: `/myGarage/Seller/CarsInNegotiation_buynow`,
          method: "GET",
          params   
        }
      }
    }),
    getOthersCarsInNegotiation: builder.query({
      query: ({ params }) => {
        return {
          url: `/myGarage/Dealer/CarsInNegotiation`,
          method: "GET",
          params   
        }
      }
    }),
    getOthersCarsInNegotiationBuyNow: builder.query({
      query: ({ params }) => {
        return {
          url: `/myGarage/Dealer/CarsInNegotiation_buynow`,
          method: "GET",
          params   
        }
      }
    }),
    getNegotiationHistoryDealer: builder.query({
      query: ({ Vehicle_Id }) => {
        return {
          url: `/negotiation-history/${Vehicle_Id}`,
          method: "GET"
        }
      }
    }),
    getNegotiationHistoryDealerBuyNow: builder.query({
      query: ({ Vehicle_Id }) => {
        return {
          url: `/negotiation-history-buy-now/${Vehicle_Id}`,
          method: "GET"
        }
      }
    }),
    getNegotiationHistory: builder.query({
      query: ({ Vehicle_Id }) => {
        return {
          url: `/negotiation-history-on-seller/${Vehicle_Id}`,
          method: "GET"
        }
      }
    }),
    getNegotiationHistoryDealer: builder.query({
      query: ({ Vehicle_Id }) => {
        return {
          url: `/negotiation-history/${Vehicle_Id}`,
          method: "GET"
        }
      }
    }),
    getNegotiationHistoryBuyNow: builder.query({
      query: ({ Vehicle_Id }) => {
        return {
          url: `/negotiation-history-on-seller-buy-now/${Vehicle_Id}`,
          method: "GET"
        }
      }
    }),
    getNegotiationHistoryBuyNowDealer: builder.query({
      query: ({ Vehicle_Id }) => {
        return {
          url: `/negotiation-history-buy-now/${Vehicle_Id}`,
          method: "GET"
        }
      }
    }),
    getNegotiationTimeoutDetails: builder.query({
      query: ({ params = {}, Vehicle_Id, Bid_Id }) => {
        return {
          url: `negotiationtimeoutdetails/${Vehicle_Id}/${Bid_Id}`,
          method: "GET",
          params
        }
      }
    }),
    getBiddersNegotiationList: builder.query({
      query: ({ params = {}, Vehicle_Id }) => {
        return {
          url: `bidhistoryonstartnegotiation/${Vehicle_Id}`,
          method: "GET",
          params
        }
      }
    }),
    getBiddersNegotiationListBuyNow: builder.query({
      query: ({ params = {}, Vehicle_Id }) => {
        return {
          url: `BuyNowBidHistoryOnStartNegotiation/${Vehicle_Id}`,
          method: "GET",
          params
        }
      }
    }),
    addNegotiation: builder.mutation({
      query: ({ payload }) => {
        return {
          url: `/negotiation`,
          method: "POST",
          body: payload
        }
      }
    })
  }),
});

export const { 
  useGetOwnCarsInNegotiationQuery,
  useGetOthersCarsInNegotiationQuery,
  useGetNegotiationHistoryDealerQuery,
  useGetNegotiationHistoryQuery,
  useAddNegotiationMutation,
  useGetNegotiationTimeoutDetailsQuery,
  useGetBiddersNegotiationListQuery,
  useLazyGetOwnCarsInNegotiationQuery,
  useLazyGetOwnCarsInNegotiationBuyNowQuery,
  useLazyGetOthersCarsInNegotiationQuery,
  useLazyGetOthersCarsInNegotiationBuyNowQuery,
  useLazyGetNegotiationHistoryDealerBuyNowQuery,
  useLazyGetNegotiationHistoryQuery,
  useLazyGetNegotiationTimeoutDetailsQuery,
  useLazyGetNegotiationHistoryBuyNowQuery,
  useLazyGetBiddersNegotiationListQuery,
  useLazyGetBiddersNegotiationListBuyNowQuery,
  useLazyGetNegotiationHistoryDealerQuery,
  useLazyGetNegotiationHistoryBuyNowDealerQuery
} = carsInNegotiationApi;
